module.exports = __webpack_public_path__ + "static/media/1.d252c9d9.jpg";